import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17d09e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-with-text" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]


    import Image from '@/components/Image.vue'
    import { useRoute, useRouter } from 'vue-router';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CardText',
  props: ['value', 'click'],
  setup(__props) {

    const router = useRouter();
    const redirect = (path: string) => {
        router.push(path);
    }

    const paragraph = __props;


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paragraph.value, (p) => {
    return (_openBlock(), _createElementBlock("div", null, [
      _createElementVNode("h3", _hoisted_1, [
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        }),
        _createTextVNode(" " + _toDisplayString(p.title) + " ", 1),
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        })
      ]),
      _createVNode(_component_el_scrollbar, {
        style: _normalizeStyle({ boxShadow: `var(--el-box-shadow-lighter)`})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "box-card",
            style: _normalizeStyle({ boxShadow: `var(--el-box-shadow-lighter)`}),
            "body-style": "padding:1rem; color:#000073; font-family: Lato, sans-serif; text-align:left;"
          }, {
            default: _withCtx(() => [
              ((typeof paragraph.click == 'string'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: p.data,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (redirect(paragraph.click)))
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: p.data
                  }, null, 8, _hoisted_3))
            ]),
            _: 2
          }, 1032, ["style"])
        ]),
        _: 2
      }, 1032, ["style"])
    ]))
  }), 256))
}
}

})